import React, { useRef, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useWindowDimensions from '../hooks/useWindowDimension';
import { checkIsOverflowed } from '../hooks/useOverflowed';
import { Tooltip } from './Tooltip';

const ListItemTitleContent = ({localeCode, itemCode, itemService}) => {
    const { i18n } = useTranslation();
    const [isOverflowed, setIsOverflowed] = useState(false);
    const ref = useRef();
    const width = useWindowDimensions();
    const localizedTitle = itemService.getLocalization(localeCode, itemCode, true, i18n);
    useEffect(() => {
        setIsOverflowed(checkIsOverflowed(ref.current));
    }, [width, localizedTitle]);
    return (
        <Tooltip content={localizedTitle} enabled={isOverflowed && Boolean(localizedTitle)}>
            <h2
                key={itemCode + localeCode}
                className="main__subtitle product__title-locale"
                ref={ref}
            >
                {localizedTitle}
            </h2>
        </Tooltip>
    );
};

export default ListItemTitleContent;
